<template>
  <div class="homelay_item_win2 text_center">
    <img :src="item.avatar" alt="" style="object-fit: contain;"/>
    <div class="gl_lv_info">
      <div class="info1">
        <div class="FontSize16">
          {{item.lawyer_name}}律师 <span class="FontSize12">{{item.lawyer_type}}</span>
        </div>
        <div class="desc FontSize14">{{item.goodat}}</div>
      </div>
      <div class="detail_info">
        <div class="name">{{item.lawyer_name}}律师 <span>{{item.lawyer_type}}</span></div>
        <div class="adress">{{item.law_firm}}</div>
        <div class="phone center">
          <svg-icon icon-class="dianhua" class="svgimg" />
          {{item.lawyer_mobile}}
        </div>
        
		<router-link to="/question/onlitform">
			<div class="btn center">在线咨询</div>
		</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props:{
		item:{
			type:Object
		}
	}
	
};
</script>

<style lang="scss" scoped>
.homelay_item_win2 {
  position: relative;
  overflow: hidden;
  &:hover {
    .gl_lv_info {
      height: 100%;
      transition: all 0.3s;
      .info1 {
        display: none;
      }
      .detail_info {
        visibility: visible;
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .gl_lv_info {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70px;
    background-color: rgba(0, 0, 0, 0.5);
    .desc {
      margin-top: 3px;
      font-size: 14px;
      color: #ffffff;
    }

    .info1 {
      padding: 16px 12px;
      text-align: left;
      color: #f8f8f8;
      span {
        margin-left: 10px;
      }
    }

    .detail_info {
      visibility: hidden;
      width: 100%;
      height: 100%;
      color: #fff;
      background-color: rgba(4, 101, 234, 0.9);
      padding: 90px 0;
      .name {
        font-size: 28px;
        > span {
          font-size: 22px;
        }
      }
      .adress {
        margin: 19px 0 16px;
      }
      .phone {
        .svgimg {
          font-size: 16px;
          color: #fff;
        }
      }
      .btn {
        width: 130px;
        height: 38px;
        background: #ffffff;
        color: #0465ea;
        border-radius: 17px;
        margin: 21px auto;
        cursor: pointer;
      }
    }
  }
}
</style>